<template>
	<section>
	  <header><em v-if="isPrev" @click="goPrev"></em><span  v-if="!isPrev" class="Glogo"></span>{{myTitle}}<span class="kf" @click="showCH"></span></header>
	  <aside id="caihong"  v-show="isShowCh">
	  	  <div>彩虹客服<em @click="showCH"></em></div>

        <router-link  tag="a" :to="{path: '/rgfw'}" class="caihong-img"></router-link>
        <div>我要咨询</div>
     
	  </aside>
 	</section>

</template>

<script>
export default {
  name: 'headerBar',
  props: {
    isPrev:{
       type:Boolean,
       default:false
     },
     myTitle:{
       type:String,
       default:"彩虹客服"
     }
     
  },
  data () {
    return {
      isShowCh: false,    
    }
  },
  methods:{
    showCH(){
      this.isShowCh = !this.isShowCh;
     
    },
    goPrev(){
      
       this.$router.go(-1)
    }
   
  }
}
</script>


<style scoped>

header{
  text-align: center;width: 7.5rem;height: 0.8rem;font-size:0.38rem;color: #c9242b;line-height: 0.8rem;background: #fff;position: relative;}
header .Glogo{
  position: absolute;
  display: inline-block;
  height: 7.2vw;
  width: 23.7vw;
  background: url(../../assets/Glogo.png) no-repeat;
  background-size: cover;
  top: 1.7vw;
  left: 4.53vw;
}
header .kf{width: 0.42rem;height: 0.41rem;background: url(../../assets/header-ico.png)  no-repeat ;background-size: cover;position: absolute;right: 0.3rem;top: 0.2rem}
header em{width: 0.25rem;height: 0.48rem;background: url(../../assets/prev.png)  no-repeat ;background-size: cover;position: absolute;left: 0.3rem;top: 0.14rem}
#caihong{width: 2.7rem;font-size: 0.26rem;color: #fff;position: absolute;background: #fff;right: 0;top: 0.8rem;border: 1px solid #e5004f;z-index: 2;}
#caihong div:nth-of-type(1){height: 0.55rem;background: #e5004f url(../../assets/ch-icon1.png) no-repeat 0.15rem center;background-size: 0.29rem 0.3rem;line-height: 0.55rem;text-align: center;}

#caihong div:nth-of-type(1) em{background: url(../../assets/close-ch.png);width: 0.13rem;height: 0.12rem;background-size: cover;position: absolute;right: 0.2rem;top: 0.2rem}
#caihong div:nth-of-type(3){height: 2.42rem;background: url(../../assets/caihong-wom.png) no-repeat center center;background-size:1.5rem 1.7rem }
#caihong div:nth-of-type(2){height: 0.68rem;line-height: 0.68rem;text-align: center;color: #000;border: 1px solid #dbdbdb}
.caihong-img{height: 2.42rem;background: url(../../assets/caihong-wom.png) no-repeat center center;background-size:1.5rem 1.7rem;display: block;}
</style>



// WEBPACK FOOTER //
// src/components/base/header.vue